var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import oneRequiredForA11y from '../utils/PropTypes/oneRequiredForA11y';
import SwitchThumb from './SwitchThumb';
var SwitchTrack = function (_PureComponent) {
  _inherits(SwitchTrack, _PureComponent);
  function SwitchTrack() {
    _classCallCheck(this, SwitchTrack);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  SwitchTrack.prototype.render = function render() {
    var _props = this.props,
      disabled = _props.disabled,
      checked = _props.checked,
      className = _props.className,
      inkDisabled = _props.inkDisabled,
      disabledInteractions = _props.disabledInteractions,
      ariaLabel = _props['aria-label'],
      ariaLabelledBy = _props['aria-labelledby'],
      props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'inkDisabled', 'disabledInteractions', 'aria-label', 'aria-labelledby']);
    return React.createElement('div', _extends({}, props, {
      className: cn('md-switch-track', {
        'md-pointer--hover': !disabled,
        'md-switch-track--disabled': disabled,
        'md-switch-track--on': checked,
        'md-switch-track--off': !checked
      }, className)
    }), React.createElement(SwitchThumb, {
      disabled: disabled,
      checked: checked,
      onClick: props.onClick,
      inkDisabled: inkDisabled,
      disabledInteractions: disabledInteractions,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy
    }));
  };
  return SwitchTrack;
}(PureComponent);
SwitchTrack.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  inkDisabled: PropTypes.bool,
  disabledInteractions: PropTypes.arrayOf(PropTypes.oneOf(['keyboard', 'touch', 'mouse'])),
  'aria-label': oneRequiredForA11y(PropTypes.string, 'aria-labelledby'),
  'aria-labelledby': PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SwitchTrack;